import { render, staticRenderFns } from "./search-card.vue?vue&type=template&id=298016e1&scoped=true"
import script from "./search-card.vue?vue&type=script&lang=js"
export * from "./search-card.vue?vue&type=script&lang=js"
import style0 from "./search-card.vue?vue&type=style&index=0&id=298016e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298016e1",
  null
  
)

export default component.exports